<template>
  <div class="level pagination">
    <a
      :class="{ inactive: !prev }"
      class="level-item button page-arrow prev"
      @click="prevClick()">
      <i class="far fa-arrow-alt-circle-left"></i>
    </a>
    <a
      :class="{ inactive: !next }"
      class="level-item button page-arrow next"
      @click="nextClick()">
      <i class="far fa-arrow-alt-circle-right"></i>
    </a>
    <div class="level-item page-num">
      <span v-if="!loading">
      {{ ((page - 1) * perPage) + 1 }} - {{ ((page - 1) * perPage) + itemCount }} of {{ total }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    next: {
      type: Boolean,
      required: true,
    },
    prev: {
      type: Boolean,
      required: true,
    },
    nextClick: {
      type: Function,
      required: true,
    },
    prevClick: {
      type: Function,
      required: true,
    },
    page: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      required: true,
    },
    itemCount: {
      type: Number,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination {
  margin: 0;

  a {
    color: whitesmoke;
    padding: 0 .25rem;
  }

  a.inactive {
    cursor: default;
    color: $link-color;
    opacity: .1;
  }

  .page-arrow {
    font-size: 1.2rem;
    background: none;
    margin: 0;
  }

  .page-num {
    font-size: .85rem;
    color: $expression-background;
    margin: 0;
    min-width: 6.5rem;
  }
}
</style>
